module.exports = __webpack_public_path__ + "img/4.c65eee1f.png";